import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class CampDefinitionApiService {

    constructor(private http: ApiHttpClient) { }

    public search(request: camps.CampDefinitionSearchRequest, showLoader: boolean = true)
        : Observable<api.OperationPagedResult<camps.CampDefinitionInfo>> {
        return this.http.post<api.OperationPagedResult<camps.CampDefinitionInfo>>('camp/search', request, showLoader);
    }

    public get(id: camps.Guid): Observable<api.OperationResultValue<camps.CampDefinitionDetails>> {
        return this.http.get<api.OperationResultValue<camps.CampDefinitionDetails>>(`camp/${id}`, true);
    }

    public getCreationContext(): Observable<api.OperationResultValue<camps.CampDefinitionCreationContext>> {
        return this.http.get<api.OperationResultValue<camps.CampDefinitionCreationContext>>(`camp/getCreationContext`, true);
    }

    public create(request: camps.CampCreateRequest): Observable<api.OperationResultValue<camps.CampDefinitionDetails>> {
        return this.http.post<api.OperationResultValue<camps.CampDefinitionDetails>>(`camp/create`, request, true);
    }

    public getAvailable(request: camps.CampsSearchRequest, showLoader: boolean = true): Observable<api.OperationResultValue<camps.CampsResponse>> {
        return this.http.post<api.OperationResultValue<camps.CampsResponse>>("camp/searchAvailable", request, showLoader);
    }

    public import(request: camps.CampDefinitionFileImportRequest, showLoader: boolean = false): Observable<api.OperationResultValue<camps.CampDefinitionFileImportResult>> {
        return this.http.post<api.OperationResultValue<camps.CampDefinitionFileImportResult>>("campdefinition/import", request, showLoader);
    }
}
